// extracted by mini-css-extract-plugin
module.exports = {"container":"collapsablePanel_container__3mXYy","button":"collapsablePanel_button__21wcI"};